import { Component, OnInit } from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  test : Date = new Date();
  env = environment
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/components/footer/footer.component.ts